module.exports = __webpack_public_path__ + "static/media/power.58c0ffcb.png";